import React, { CSSProperties, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Body1 } from '@ui/Typography'
import { Skeleton } from '@ui/v2/Skeleton'

import { PaymentProviderQrDto } from '@model/MasterTransactionDto'

import { Box } from '@shared/components/Box'

interface QrCodeDisplayProps {
  qr: PaymentProviderQrDto
}

const QR_SIZE = 160
const QR_IMAGE_STYLE: CSSProperties = { objectFit: 'contain' }

export const QrCodeDisplay: React.FC<QrCodeDisplayProps> = ({ qr }) => {
  const { t } = useTranslation()
  const [loaded, setLoaded] = useState(false)
  const preparedQr = qr?.prepared

  useEffect(() => {
    setLoaded(false)
  }, [preparedQr])

  if (!preparedQr) return null

  return (
    <Box flex direction='column' align='center' gap='x4'>
      {!loaded && <Skeleton variant='rounded' width={QR_SIZE} height={QR_SIZE} />}
      <img
        width={QR_SIZE}
        height={QR_SIZE}
        hidden={!loaded}
        src={preparedQr}
        alt={t('Scan to pay')}
        style={QR_IMAGE_STYLE}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
      />
      <Body1 color='text-med-em'>{t('Scan to pay')}</Body1>
    </Box>
  )
}
